import styled from 'styled-components'
import { Drawer } from 'antd'

import { Close } from 'icon'
import { PrimaryBtn } from 'components/button'

const BaseDrawer = (props) => {
  const {
    title,
    text,
    loading,
    width,
    children,
    visible,
    btn,
    onClose,
    onSave,
  } = props

  const txt = title ? <Title>{title}</Title> : ''
  const content = btn ? (
    btn
  ) : (
    <PrimaryBtn
      loading={loading}
      text={text}
      disabled={!onSave}
      onClick={onSave}
    />
  )
  return (
    <Drawer
      title={txt}
      className="drawer-content"
      height="90%"
      width={width}
      placement={'right'}
      closable={false}
      onClose={onClose}
      open={visible}
    >
      <Btn onClick={onClose}>
        <Close />
      </Btn>
      <Body>
        <Html>{children}</Html>
        <Button>
          <SaveButton>{content}</SaveButton>
        </Button>
      </Body>
    </Drawer>
  )
}

const Body = styled.div`
  position: relative;
  min-height: 85vh;
  margin-top: 8px;
`

const Html = styled.div`
  padding: 0px;
  width: 100%;
  max-height: 80vh;
  overflow: auto;
`

const Title = styled.div`
  width: 100%;
  font-size: 18px;
  text-align: center;
  color: ${(p) => p.theme.color.grey.high};
`

const Btn = styled.span`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
`

const SaveButton = styled.div`
  width: 250px;
  margin: 0 auto;
`

const Button = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
`

export default BaseDrawer
